import React, { useState, useEffect } from 'react'
import { getDealerDetailsList, DeleteDealerData } from './ActionCreator'
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Nodataimage from '../../../../../images/nodata.png'

const itemsPerPage = 10;
export default function List({ handleTab, handleEditingData }) {
    const [loader, setLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [listData, setListData] = useState([])
    const [filteredData, setfilteredData] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        getDealerDetailsListFn()
    }, [])

    const getDealerDetailsListFn = () => {
        setLoader(true)
        getDealerDetailsList(callback => {
            console.log("cal", callback)
            setLoader(false)
            if (callback?.message == "success" && callback?.status == 200) {
                setCurrentPage(1)
                setListData(callback?.data)
                filterFunction(callback?.data, 1)
            } else {
                setListData([])
            }
        })
    }

    const filterFunction = (data, currentPageNo) => {
        const indexOfLastItem = currentPageNo * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
        setfilteredData(currentItems)
    }

    const handleDelete = (data) => {
        setLoader(true)
        DeleteDealerData(data?.id, callback => {

            setLoader(false)
            if (callback?.message == "success" && callback?.status == 200) {
                setPopup({ show: true, popupStatus: "Dealer Deleted Successfully" })
                 getDealerDetailsListFn()
            } else {
                setPopup({ show: true, popupStatus: "Error Deleting Dealer" })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleEdit = (data) => {
        handleEditingData(data)
        handleTab("add")
    }


    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        filterFunction(tableData,value)
    };
    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                {
                    filteredData && filteredData?.length > 0 ?
                        <>
                            <div className='phocket-table-new'style={{borderRadius:'15px',paddingBottom:'2px', marginTop: '20px', boxShadow: 'rgba(0, 0, 0, 0.2) 0px 4px 8px 0px' }}>
                                <div style={{ overflowX: 'auto' }}>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className='text-center'>Name</th>
                                                <th className='text-center'>Email Id</th>
                                                <th className='text-center'>Mobile No.</th>
                                                <th className='text-center'>License Id</th>
                                                <th className='text-center'>Share URL</th>
                                                <th className='text-center'>Mobile Verified </th>
                                                <th className='text-center'>Is Active </th>
                                                <th className='text-center'>Added On </th>
                                                <th className='text-center'>Edit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredData?.map((val, id) => {
                                                    return (
                                                        <tr>
                                                            <td className='text-center'>{val?.name}</td>
                                                            <td className='text-center'>{val?.emailId}</td>
                                                            <td className='text-center'>{val?.mobileNo}</td>
                                                            <td className='text-center'>{val?.licenseId}</td>
                                                            <td className='text-center'>
                                                                <div style={{display:'flex',gap:'5px',justifyContent:'center',alignItems:'center'}}>
                                                                    {val?.shareUrl} 
                                                                    {
                                                                        val?.shareUrl !== undefined && val?.shareUrl!== null && val?.shareUrl?.length > 0 ? 
                                                                        <ContentCopyIcon style={{cursor:'pointer'}} onClick={()=>navigator.clipboard.writeText(val?.shareUrl)}/>
                                                                    :''}
                                                                </div>
                                                            </td>
                                                            <td className='text-center'>{val?.mobileVerified == true ? "Yes" : "No"}</td>
                                                            <td className='text-center'>{val?.active == true ? "Yes" : "No"}</td>
                                                            <td className='text-center'>{moment(val?.addedOn).format("DD-MM-YYYY")}</td>
                                                            <td style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                                <button onClick={() => handleEdit(val)}>
                                                                    <i className='fa fa-edit'></i>
                                                                </button>
                                                                <button onClick={() => handleDelete(val)}>
                                                                    <i className='fa fa-trash-o'></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                 <div style={{ display: 'flex', justifyContent: 'end', margin: '10px 0' }}>
                                                                    <Pagination
                                                                        count={Math.ceil(listData?.length / itemsPerPage)}
                                                                        page={currentPage}
                                                                        onChange={handlePageChange}
                                                                        color="primary"
                                                                    />
                                                                </div>
                            </div>
                            
                        </>
                        : 
                         <div className='text-center'>
                                                    <img src={Nodataimage} width={"30%"} />
                                                </div>
                        }

            </div>
        </>
    )
}
